import { getTravleDetailNav } from '@/axios/api'

const travleDetailNav = {
  state: {
    travleDetailNav: {}
  },
  mutations: {
    SET_TRAVLEDETAILNAV (state, travleDetailNav) {
      state.travleDetailNav = travleDetailNav
    }
  },
  actions: {
    TRAVLEDETAILNAV ({ commit }, params) {
      getTravleDetailNav(params).then(res => {
        this.state.travleDetailNav = res.data.data
      })
    }
  }
}

export default travleDetailNav



// WEBPACK FOOTER //
// ./src/store/modules/getTravleDetailNav.js